import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSendData } from "../../../Store/Slice/scheduleSlice";

export default function Card({ item }) {
  const dispatch = useDispatch();
  const sendData = useSelector((state) => state.rootReducer.scheduleSlice.sendData);

    const cardHandler = () => {
        dispatch(setSendData({
            payment_method_id: item.id,
            payment_brand: item?.payment_method_data?.brand ?? item.brand
        }));
    };

    let isCardSelected = sendData?.payment_method_id === item?.id;

  return (
    <div className="payment__cards-item">
      <input
          type="radio"
          name="card"
          id={item?.id}
          onChange={cardHandler}
          value={item?.id}
          checked={isCardSelected}
      />
      <label htmlFor={item?.id}>
        <div className="circle">
          <img src="/assets/icons/check-arrow.svg" alt="arrow" />
        </div>
        <div className="info">
          <div className="text">{item?.payment_method_data?.brand ?? 'visa'}</div>
          <div className="number">
            •••• •••• •••• {item?.payment_method_data?.last4}
          </div>
        </div>
      </label>
    </div>
  );
}
